import { render, staticRenderFns } from "./QuoteCommercialEditor.vue?vue&type=template&id=af96f806&scoped=true"
import script from "./QuoteCommercialEditor.vue?vue&type=script&lang=js"
export * from "./QuoteCommercialEditor.vue?vue&type=script&lang=js"
import style0 from "./QuoteCommercialEditor.vue?vue&type=style&index=0&id=af96f806&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af96f806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af96f806')) {
      api.createRecord('af96f806', component.options)
    } else {
      api.reload('af96f806', component.options)
    }
    module.hot.accept("./QuoteCommercialEditor.vue?vue&type=template&id=af96f806&scoped=true", function () {
      api.rerender('af96f806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/quotes/QuoteCommercialEditor.vue"
export default component.exports